import Bluebird from 'bluebird';
import moment from 'moment';

import { getServerTime } from './getServerTime';
import { ReportFileMetadataUsageEnum, ReportFileTypeEnum, uploadReportAttachment } from './reportAttachmentSignedUrl';

const uploadReportSelfie = (
  documentURI: File | string,
  siteKey: string,
  reportKey: string,
  cancelHandler: () => any
): Promise<string> => {
  return new Bluebird((resolve: (T: any) => void, reject: (E: Error) => any, onCancel: (A?: any) => any) => {
    // Already-uploaded path — passthrough
    if (typeof documentURI === 'string') {
      return resolve(documentURI);
    }

    if (onCancel) {
      onCancel(cancelHandler);
    }

    const timestamp = moment(getServerTime()).unix();
    const fileExt = (documentURI as File).name.split('.').pop();
    const blob = (documentURI as File).slice(0, (documentURI as File).size, (documentURI as File).type);
    const newNameFile = new File([blob], `${timestamp}.${fileExt}`, {
      type: (documentURI as File).type
    });

    uploadReportAttachment({
      body: {
        fileName: newNameFile.name,
        fileType: ReportFileTypeEnum.IMAGE,
        mimeType: newNameFile.type || 'image/jpeg',
        reportID: reportKey,
        siteID: siteKey,
        usageType: ReportFileMetadataUsageEnum.SELFIE_SIGNATURES,
        questionIndex: -1,
        childQuestionIndex: ''
      },
      file: newNameFile
    })
      .then(filePath => resolve(filePath))
      .catch(err => reject(err));
  }).then((res: string) => {
    return res ? res : '';
  });
};

export default uploadReportSelfie;
